// Module
var code = " <media-collections-sidebar collection-states=\"$ctrl.collectionStates\" create-new-empty-collection=\"$ctrl.createNewEmptyCollection()\"></media-collections-sidebar> ";
// Exports
module.exports = code;